module.exports = __webpack_public_path__ + "img/рз_belly_protuberance.064a3253.png";